export const LastNames = [
  "Breath",
  "Queen",
  "Engine",
  "Thanks",
  "Payment",
  "Actor",
  "Writer",
  "Garbage",
  "Song",
  "Goal",
  "Friendship",
  "Estate",
  "Chest",
  "Disease",
  "Stranger",
  "Poet",
  "Member",
  "Throat",
  "Honey",
  "Diamond",
  "Nature",
  "Photo",
  "Buyer",
  "Winner",
  "Bread",
  "Blood",
  "Contract",
  "Basis",
  "Coffee",
  "Gate",
  "Desk",
  "Mall",
  "Art",
  "Painting",
  "Fish",
  "Map",
  "Mood",
  "Reading",
  "Dad",
  "Sister",
  "Hotel",
  "Wood",
  "Story",
  "Guidance",
  "Paper",
  "Weakness",
  "Salad",
  "Son",
  "Frog",
  "Cat",
  "Dolphin",
  "Fish",
  "Stinker",
  "Slag",
  "Ladder",
  "King",
  "Trainer"
]

export const FirstNames = [
  "Fast",
  "Slow",
  "Big",
  "Small",
  "Tall",
  "Short",
  "Wide",
  "Thin",
  "Long",
  "Round",
  "Dark",
  "Bright",
  "Heavy",
  "Light",
  "Sweet",
  "Sour",
  "Bitter",
  "Spicy",
  "Soft",
  "Hard",
  "Rough",
  "Smooth",
  "Warm",
  "Cold",
  "Hot",
  "Cold",
  "Wet",
  "Dry",
  "New",
  "Old",
  "Young",
  "Happy",
  "Sad",
  "Angry",
  "Calm",
  "Loud",
  "Quiet",
  "Lazy",
  "Busy",
  "Glad",
  "Sad",
  "Easy",
  "Tough",
  "Kind",
  "Rude",
  "Rich",
  "Poor",
  "Nice",
  "Mean",
  "Friendly",
  "Harsh",
  "Funny",
  "Serious",
  "Pretty",
  "Ugly",
  "Fierce",
  "Gentle",
  "Quick",
  "Fast",
  "Slow",
  "Lively",
  "Dull",
  "Sweet",
  "Salty",
  "Bitter",
  "Sour",
  "Tasty",
  "Yummy",
  "Nasty",
  "Energetic",
  "Lazy",
  "Fresh",
  "Stale",
  "Clean",
  "Dirty",
  "Precious",
  "Cheap",
  "Huge",
  "Tiny",
  "Smiling",
  "Frowning",
  "Blonde",
  "Brunette",
  "Redhead",
  "Smooth",
  "Rough",
  "Gorgeous",
  "Plain",
  "Famous",
  "Unknown",
  "Popular",
  "Unliked",
  "Lucky",
  "Unlucky",
  "Helpful",
  "Hurtful",
  "Brave",
  "Scared",
  "Brave",
  "Timid",
  "Real",
  "Fake",
  "Fierce",
  "Gentle"
]

